'use strict'

const LOAD_METRICS_LIST_VIEW = "LOAD_METRICS_LIST_VIEW";
const LOAD_METRICS_LIST_VIEW_SUCCESS = "LOAD_METRICS_LIST_VIEW_SUCCESS";
const LOAD_METRICS_LIST_VIEW_CANCELLED = "LOAD_METRICS_LIST_VIEW_CANCELLED";
const ERROR_LOAD_METRICS_LIST_VIEW = "ERROR_LOAD_METRICS_LIST_VIEW";
const ERROR_FILTERS_NOT_SELECTED = "ERROR_FILTERS_NOT_SELECTED";

const LOAD_METRICS_FILTER_REQUEST = "LOAD_METRICS_FILTER_REQUEST";
const LOAD_METRICS_FILTER_SUCCESS = "LOAD_METRICS_FILTER_SUCCESS";

const CHANGE_FILTER_VALUE = "CHANGE_FILTER_VALUE";
const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
const SET_STAT_CARD_TEXT = "SET_STAT_CARD_TEXT";
const SET_STAT_COUNT = "SET_STAT_COUNT";

const TO_DATE_FORMAT = "YYYY-MM-DD 23:59:59";
const FROM_DATE_FORMAT = "YYYY-MM-DD 00:00:00";
const DEFAULT_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export {
    LOAD_METRICS_LIST_VIEW,
    LOAD_METRICS_LIST_VIEW_SUCCESS,
    LOAD_METRICS_LIST_VIEW_CANCELLED,
    ERROR_LOAD_METRICS_LIST_VIEW,
    ERROR_FILTERS_NOT_SELECTED,
    TO_DATE_FORMAT,
    FROM_DATE_FORMAT,
    DEFAULT_DATE_FORMAT,
    LOAD_METRICS_FILTER_SUCCESS,
    CHANGE_FILTER_VALUE,
    SET_ERROR_MESSAGE,
    SET_STAT_CARD_TEXT,
    SET_STAT_COUNT,
    LOAD_METRICS_FILTER_REQUEST
}
